//componente de Alerta para mostrar mensajes de éxito o error.
export const Alert = ({ message, type, onClose }) => {
    if (!message) return null;
    const baseClasses = "p-4 mb-4 text-sm rounded-lg relative";
    const typeClasses = { error: "bg-red-100 text-red-800", success: "bg-green-100 text-green-800" };
    return (
        <div className={`${baseClasses} ${typeClasses[type]}`} role="alert">
            <span className="font-medium">{message}</span>
            <button onClick={onClose} className="absolute top-0 right-0 mt-2 mr-3 text-2xl font-semibold leading-none">&times;</button>
        </div>
    );
};